import React from 'react';
import styled, { css } from 'styled-components';

const Image = styled.img`
    width: ${({ width }) => (width && `${width}px`) || 'auto'};
    height: ${({ height }) => (height && `${height}px`) || 'fit-content'};
    max-height: ${({ maxHeight }) => (maxHeight && `${maxHeight}px`) || '55px'};
    ${({ maxWidth }) => maxWidth && css`max-width: ${maxWidth}px`};
    ${({ grayscale, contrast }) => {
        if (grayscale || contrast) {
            return css`filter:
                ${grayscale && `grayscale(${grayscale}%)`}
                ${contrast && `contrast(${contrast}%)`}
            `;
        }
    }}
`;

export default Image;
